import { alpha, ListItemButton } from "@mui/material";
import { useContext } from "react";
import Image from "src/components/Image";
import CustomContext from "src/pages/App/AppSettings/Customization/context";
import palette from "src/theme/palette";
import { ConnectedEntity } from "src/types/apps";
import { entitiesUrl } from "src/utils/formatUrl";

import Context from "../../context";

// ----------------------------------------------------------------------

type Props = {
	item: ConnectedEntity;
};

const sx = {
	borderRadius: 1,
	m: 1,
	p: 4,
	backgroundColor: "white",
	justifyContent: "center",
	cursor: "pointer"
};

export const EntityItemBtn = ({ item }: Props) => {
	const { values } = useContext(Context);
	const { state } = useContext(CustomContext);
	const shadowColor = state.type === "DARK" ? "#000000" : palette.light.grey[500];
	return (
		<ListItemButton
			key={item.id}
			sx={{
				...sx,
				backgroundColor: values.contentBackgroundColor,
				boxShadow: `0 0 2px 0 ${alpha(shadowColor, 0.2)}, 0 12px 24px -4px ${alpha(
					shadowColor,
					0.12
				)}`
			}}
		>
			<Image src={entitiesUrl(item.id)} />
		</ListItemButton>
	);
};

export default EntityItemBtn;
